export default __webpack_public_path__ + "static/media/printer.5e9cc674.svg";